module.exports = __webpack_public_path__ + "media/diverticulum.6f399c57.wav";